import type { ReactNode } from 'react';

export const MAIN_CONTENT_ID = 'main-content';

/**
 * 앱 셸 한 벌 — D3 §4.6 `ScreenFrame`의 최소 구현. `packages/ui`에 생기면 교체한다.
 *
 * 헤더와 서브내비는 콘텐츠 스크롤 영역 밖이라 늘 보인다(D145 ① · L2-06 §8 단일 화면 유지).
 * 본문으로 건너뛰는 링크가 첫 초점이다(D145 ⑨).
 */
export interface ScreenFrameProps {
  header?: ReactNode;
  subNav?: ReactNode;
  /** 라우트가 바뀌면 새 화면 이름을 polite로 알린다. */
  announcement?: string;
  children: ReactNode;
}

export function ScreenFrame({ header, subNav, announcement, children }: ScreenFrameProps) {
  return (
    <div className="bg-canvas flex h-dvh flex-col overflow-hidden">
      {header ? (
        <a
          href={`#${MAIN_CONTENT_ID}`}
          className="bg-surface-raised text-ink focus-visible:ring-focus z-popover px-card py-snug sr-only rounded-md text-sm font-medium focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus-visible:ring-2"
        >
          본문으로 건너뛰기
        </a>
      ) : null}
      {header}
      {subNav ? (
        <div className="border-line bg-canvas px-gutter shrink-0 border-b">{subNav}</div>
      ) : null}
      <main
        id={MAIN_CONTENT_ID}
        tabIndex={-1}
        className="min-h-0 flex-1 overflow-hidden outline-none"
      >
        {children}
      </main>
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {announcement}
      </div>
    </div>
  );
}
